import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RainfallChartUpdateService } from '../rainfall-chart/rainfall-chart.update.service';

@Injectable()
export class FlowmeterChartUpdateService extends RainfallChartUpdateService {
}
